import { createContext, useEffect, useState } from "react";
import { Button, Col, Row, Card, Container, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useSignatureLogic from "./hooks/useSignatureLogic.js";
import BatchClassDetails from "./components/BatchClassDetails";
import Loader2 from "../../../components/Loader2";
import Signature from "../CommonComponents/Signature/Signature";
import { Select } from "antd";
import { addDefaultOption } from "../../../utils/utility.js";
import StudentSession from "./components/StudentSession.jsx";


export const BcaContext = createContext(null);


export default function CreateAttendance() {
    const { id } = useParams();



    const context = useSignatureLogic(id);
    const [applyAllSessions, setApplyAllSessions] = useState(false);

    const { 
        studentData,
        isLoadingResources, 
        handleSubmit, 
        loadSignatures,
        form,
        updateForm,
        sessionOptions,
        selectedDateData,

     } = context ?? {};

    if (isLoadingResources) return <Loader2 />; 



    return (
        <BcaContext.Provider value={context}>
            <Container fluid className="">
                <Row>
                    <Col md={12}>
                        <h3 className="m-0 p-0 fw-bolder">
                            Class - Student Attendance
                        </h3>
                        {/* <small className="m-0 p-0 text-muted">
                            19 Students
                        </small> */}
                    </Col>
                </Row>
                <Row className="g-3]">
                    {/* Card A */}
                        <BatchClassDetails batchData={studentData?.student?.batch ?? []} />

                    {/* Card B */}
                    <Col xxl={8}>
                        <div>
                            <h4 className="fw-bold text-primary">Attendance Details</h4>
                            <Row className="mb-3">
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Student Name</Form.Label>
                                        <Form.Control 
                                            type="text"
                                            value={studentData?.student?.enrolment?.name}
                                            readOnly
                                        />
                                    </Form.Group>
                                </Col>

                                <Col>
                                    <Form.Group>
                                        <Form.Label>Date</Form.Label>
                                        <Col md={12}>
                                            <Select
                                                isClearable
                                                className="react-select-container render-above w-100"
                                                classNamePrefix="react-select"
                                                options={[
                                                    { value: "", label: "Select a date" },
                                                    ...(studentData?.student?.student_training_dates?.map(item => ({
                                                        value: item.id,
                                                        label: item.date,
                                                    })) ?? [])
                                                ]}
                                                onChange={(opt) => {
                                                    updateForm("training_date", opt);
                                                    updateForm("training_session", null);
                                                    setApplyAllSessions(false);

                                                }}
                                                
                                                name="student_date"
                                                placeholder="Dates"
                                            />
                                        </Col>
                                    </Form.Group>
                                </Col>

                                {!applyAllSessions && (
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Session</Form.Label>
                                            <Col md={12}>
                                                <Select
                                                    isClearable
                                                    isDisabled={sessionOptions.length === 0}
                                                    className="react-select-container render-above w-100"
                                                    classNamePrefix="react-select"
                                                    options={sessionOptions}
                                                    name="student_session"
                                                    placeholder="Select session"
                                                    value={form?.training_session}
                                                    onChange={(opt) => updateForm("training_session", opt)}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Col>
                                )}
                                <Col>
                                    <Form.Check
                                        type="checkbox"
                                        label="Apply all sessions"
                                        className="mt-2"
                                        disabled={sessionOptions.length === 0}
                                        checked={applyAllSessions}
                                        onChange={(e) => {
                                            const checked = e.target.checked;
                                            setApplyAllSessions(checked);

                                            updateForm(
                                                'training_session',
                                                checked ? sessionOptions : null
                                            );
                                        }}
                                    />

                                </Col>
                            </Row>
                        </div>
                        <div>
                            <h4 className="fw-bold text-primary">Signature</h4>

                            <Signature 
                                onSubmit={handleSubmit} 
                                studentId={studentData?.student?.student_id}
                                loadingSignatures={loadSignatures}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                         <StudentSession 
                            trainingDates={studentData?.training_dates}
                         />

                    </Col>
                </Row>
            </Container>
        </BcaContext.Provider>
    );
}
